import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useParams} from 'react-router-dom'
import Highlighter from 'react-highlight-words'
import {apiGetGreyKeywords} from '../../apis/Grey'
import axios from 'axios'
import {toast} from 'react-toastify'

export function PlaceMessageDetail() {

  const {message_id} = useParams<{message_id: string}>()

  const [items, setItems] = useState<any>([])

  const [loading, setLoading] = useState(false)

  const [greyKeywords, setGreyKeywords] = useState([])

  useEffect(() => {

    getGreyKeywords()
    getMessages()

    return () => {

    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getMessages = () => {
    setItems([])
    setLoading(true)
    axios.get(`${process.env.REACT_APP_API2_URL}am/place/message/${message_id}`).then(({data: {error, result}}) => {
      console.log(error)
      console.log(result)
      if (error !== '') {
        toast.error(error)
      } else {
        //setBooking(result.booking)
        setItems(result)
      }
      setLoading(false)
    }).catch((error) => {
      console.log(error)
      setLoading(false)
    })
  }

  const getGreyKeywords = () => {
    apiGetGreyKeywords().then(({error, result}) => {
      console.log(error)
      console.log(result)
      if (error !== '') {
      } else {
        setGreyKeywords(result)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  return <>
    <PageTitle breadcrumbs={[]}>메시지</PageTitle>
    <div style={{
      padding: 20,
      borderRadius: 20,
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>

      <div style={{
        padding: 20,
        borderRadius: 20,
        backgroundColor: 'white',
        width: '100%',
      }}>
        {
          loading ?
            <div style={{
              width: '100%',
              height: 400,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <span className='indicator-progress' style={{display: 'block'}}>Loading...<span className='spinner-border spinner-border-sm align-middle ms-2' /></span>
            </div>
            :
            <div>

              { items !== null &&
                <>
                  <div className='mb-10'>
                    <label onClick={() => {
                      window.open(`/place/${message_id.split("_")[0]}`, '_blank')
                    }} className='btn btn-primary' style={{marginRight:20}} >장소 : {message_id.split("_")[0]}</label>
                    <label onClick={() => {
                      window.open(`/user/${message_id.split("_")[1]}`, '_blank')
                    }} className='btn btn-primary' style={{marginRight:20}}>호스트 : {message_id.split("_")[1]}</label>
                    <label onClick={() => {
                      window.open(`/user/${message_id.split("_")[2]}`, '_blank')
                    }} className='btn btn-primary'>게스트 : {message_id.split("_")[2]}</label>
                  </div>
                </>

              }

              {
                items !== null &&
                items.map((message: any, messageIndex: number) => {
                  return (
                    <div style={{
                      display: 'flex',
                      justifyContent: message.user_id === Number(message.message_id.split("_")[1]) ? 'flex-end' : 'flex-start',
                    }} key={`message_${messageIndex}`}>
                      <div className='shadow mb-5 p-5' style={{
                        width: 'fit-content',
                        textAlign: message.user_id === Number(message.message_id.split("_")[1]) ? 'right' : 'left',
                      }}>
                        <p>{message.name} [{message.host_name}]</p>
                        {
                          message.type === 'I' ?
                            <a href={`${message.message}.jpg`} target={'_blank'} rel={'noopener noreferrer'}>
                              <img src={`${message.message}.jpg`} className='img-thumbnail' style={{
                                maxWidth: 200,
                              }} alt={''} />
                            </a>
                            :
                            <h4 style={{
                              whiteSpace: 'pre-wrap',
                            }}>
                              <Highlighter
                                searchWords={greyKeywords}
                                autoEscape
                                highlightStyle={{
                                  backgroundColor: 'red',
                                  color: 'white',
                                }}
                                textToHighlight={message.message ?? ''}
                              />
                            </h4>
                        }
                        <br />
                        {message.created_at}
                      </div>
                    </div>
                  )
                })
              }
            </div>
        }
      </div>
    </div>
  </>
}

